import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CartLoading from './CartLoading';
import { getUserCart, getShippingCost, checkoutCart } from './../../../apis/requests';
import { Link, useNavigate } from 'react-router-dom';
import { formatPrice } from '../../../utils/utils';
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { Button } from 'primereact/button';
import useLang from '../../../hooks/useLang';
import Select from 'react-select';
import countries from '../../../assets/json/countries.json';
import dailCodes from './../../../assets/json/dailCodes.json';
import config from './../../../config/config.json';
import { Checkbox } from 'primereact/checkbox';
import { InputSwitch } from 'primereact/inputswitch';
import store from '../../redux/store';
import { setCartCount } from '../../redux/reducer';
import CryptoJS from "crypto-js";
import parsePhoneNumber from 'libphonenumber-js'
import { encrypt } from '../../../utils/utils';
const Checkout = () => {
    const shippingConfig = JSON.parse(store.getState().app.storeMetaData.store.shippingConfig);
    const user = store.getState().app.user;
    const { t } = useTranslation();
    const navigate = useNavigate();
    const lang = useLang();
    const [loading, setLoading] = useState(true);
    const [btnLoading, setBtnLoading] = useState(false);
    const [firstName, setFirstName] = useState(user?.name);
    const [lastName, setLastName] = useState(user?.lastName);
    const [email, setEmail] = useState(user?.email);
    const [phone, setPhone] = useState();
    const [cartItems, setCartItems] = useState([]);
    const [country, setCountry] = useState(config.defaultCountry);
    const [states, setStates] = useState();
    const [city, setCity] = useState();
    const [area, setArea] = useState();
    const [street, setStreet] = useState();
    const [house, setHouse] = useState();
    const [apt, setApt] = useState();
    const [notes, setNotes] = useState();
    const [paymentMode, setPaymentMode] = useState(config.defaulyPaymentMode);
    const [createAccount, setCreateAccount] = useState(false);
    const [selectedState, setSelectedState] = useState({});
    const [dailCode, setDailCode] = useState(config.defaultDailCode);
    const [formError, setFormError] = useState(false);
    const [cartPrice, setCartPrice] = useState({
        subTotal: 0,
        saved: 0,
        grandTotal: 0,
        shippingCharge: shippingConfig.defaultShipping,
    });
    useEffect(() => {
        try {
            if (user.phone !== undefined) {
                setPhone(parsePhoneNumber(user?.phone).nationalNumber);
            }
        } catch (error) {
            console.log(error);
        }
        loadGetuserCart();
        let countryStates = countries.filter((c) => c.code3 === country.code3)[0];
        setStates(countryStates.states);
    }, []);
    const loadGetuserCart = async () => {
        try {
            let params = {
                cart_id: localStorage.getItem('cart'),
            }
            const res = await getUserCart(params);
            setCartItems(res.data.cartItems);
            let sum = 0;
            let saved = 0;
            let subTotal = 0;
            let totalQuantity = 0;
            res.data.cartItems.forEach((citem) => {
                totalQuantity += citem.item_quantity;
                subTotal += citem.item_sale_price_without_discount * citem.item_quantity;
                if (citem.discount_end_date === null) {
                    sum += citem.item_sale_price_without_discount * citem.item_quantity;
                } else {
                    let discount_end_date = new Date(citem.discount_end_date);
                    if (discount_end_date <= Date.now()) {
                        sum += citem.item_sale_price_without_discount * citem.item_quantity;
                    } else {
                        sum += citem.item_sale_price * citem.item_quantity;
                        saved += citem.item_discount * citem.item_quantity;
                    }
                }
            });
            setCartPrice({
                saved: saved,
                subTotal: subTotal,
                grandTotal: sum,
                shippingCharge: calculateShippingPrice(sum),
                totalQuantity: totalQuantity,
                couponAmount: 0
            });
            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    }

    const calculateShippingPrice = (price = 0, fromAPI = false) => {
        const { freeShippingAfter, defaultShipping } = shippingConfig;
        // Case 1: Free shipping disabled (-1) and no API state yet
        if (freeShippingAfter === -1 && !fromAPI) {
            return defaultShipping;
        }
        // Case 2: Free shipping threshold reached (only when not fromAPI)
        if (price > freeShippingAfter && !fromAPI) {
            return 0;
        }
        // Case 3: Shipping price from API (state selected, data exists)
        if (fromAPI) {
            return fromAPI;
        }
        // Case 4: State selected but no API data → fallback to default
        return defaultShipping;
    };

    const checkForFormError = (field, mail = false) => {
        if (mail) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return !(field && emailRegex.test(field));
        } else {
            return !!((field === undefined || field?.length === 0));
        }
    }
    const checkAllMandatoryFields = () => {
        const fields = [firstName, lastName, email, phone, city, area, street, house];
        const flag = fields.every(item => item !== undefined && item !== null && String(item).trim().length > 0);
        setFormError(!flag);
        return flag;
    }
    const loadShippingCost = async (code) => {
        try {
            setBtnLoading(true);
            let params = {
                zone_state: code,
                country: country.code3,
            }
            const res = await getShippingCost(params);
            setCartPrice({
                saved: cartPrice.saved,
                subTotal: cartPrice.subTotal,
                grandTotal: cartPrice.grandTotal,
                shippingCharge: res.data.data !== "LOAD_DEFAULT" ? calculateShippingPrice(cartPrice.grandTotal, res.data.data.shipping_charge) : calculateShippingPrice(cartPrice.grandTotal),
                totalQuantity: cartPrice.totalQuantity,
            });
            setBtnLoading(false);

        } catch (error) {
            setBtnLoading(false);
            console.log(error);

        }
    }
    const handleCheckoutCart = async () => {
        try {
            let flag = checkAllMandatoryFields();
            let cartId = localStorage.getItem('cart');
            let cpk = await encrypt(JSON.stringify(cartPrice));
            if (flag) {
                setBtnLoading(true);
                let data = {
                    firstName: firstName,
                    lastName: lastName,
                    email: email,
                    dailCode: dailCode.dial_code,
                    phone: phone,
                    country: country.name,
                    state: selectedState.name,
                    city: city,
                    area: area,
                    street: street,
                    house: house,
                    notes: notes,
                    cartId: cartId,
                    createAccount: createAccount,
                    paymentMode: paymentMode,
                    cpk: cpk,
                    apartment: apt,
                    totalItems: cartItems.length,
                }
                const res = await checkoutCart(data);
                setBtnLoading(false);
                localStorage.removeItem('cart');
                store.dispatch(setCartCount(0));
                if (paymentMode === "online") {
                    window.location.assign(res.data.paymentLink);
                } else {
                    navigate('/checkout/success');
                }
            }

        } catch (error) {
            setBtnLoading(false);
            console.log(error);
        }


    }


    return (
        <div className='lg:p-10 '>

            {
                loading &&
                <CartLoading />
            }
            {
                (!loading && cartItems.length === 0) &&
                <div className='flex content-center' >
                    <div className='text-center mb-4'>
                        <img src='/svg/landing.svg' alt='no_data' className='w-150' />
                        <Link to="/shop">{t('empty_cart_msg')}</Link>
                    </div>
                </div>
            }
            {
                (!loading && cartItems.length !== 0) &&
                <div className='p-3'>
                    <h1 className='text-3xl mt-3'>{t('checkout_cart')}</h1>
                    <div className="grid gap-3 grid-cols-1 sm:grid-cols-12 py-4">
                        <div className="col-span-12 md:col-span-12 lg:col-span-7">
                            <div className='lg:mx-5 mx-2'>
                                <form action="">
                                    <div className="mb-3">
                                        <h6 className='text-xl'>{t('fill_your_details')}</h6>
                                    </div>
                                    <div className='grid lg:grid-cols-2 md:grid-cols-2 gap-3'>
                                        <div className='grid-cols-2'>
                                            <div className="form-group">
                                                <label htmlFor="firstName" className='required mb-1'>{t('first_name')}</label>
                                                <InputText
                                                    value={firstName}
                                                    onChange={(e) => {
                                                        setFirstName(e.target.value);
                                                    }}
                                                    className='pr-input'
                                                    invalid={formError && checkForFormError(firstName)}
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <div className="form-group">
                                                <label htmlFor="lastName" className='required mb-1'>{t('last_name')}</label>
                                                <InputText
                                                    className='pr-input'
                                                    value={lastName}
                                                    onChange={(e) => {
                                                        setLastName(e.target.value);
                                                    }}
                                                    invalid={formError && checkForFormError(lastName)}
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <div className="form-group">
                                                <label htmlFor="email" className='required mb-1'>{t('email')}</label>
                                                <InputText
                                                    type="email"
                                                    className='pr-input'
                                                    value={email}
                                                    onChange={(e) => {
                                                        setEmail(e.target.value);
                                                    }}
                                                    invalid={formError && checkForFormError(email, true)}
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <div className="form-group">
                                                <label htmlFor="mobileNumber" className='required mb-1'>{t('mobile_number')}</label>
                                                <div className="p-inputgroup flex-1">
                                                    <Select
                                                        className='w-50'
                                                        placeholder={t('select')}
                                                        options={dailCodes}
                                                        value={dailCode}
                                                        getOptionLabel={(d) => d.dial_code}
                                                        getOptionValue={(d) => d.dial_code}
                                                        onChange={(e) => {
                                                            setDailCode(e)
                                                        }}
                                                        styles={{
                                                            control: (baseStyles, state) => ({
                                                                ...baseStyles,
                                                                padding: 2,
                                                                marginTop: 5,
                                                                borderRight: lang === "en" ? 'none' : "auto",
                                                                borderRadius: 0,
                                                                borderTopLeftRadius: lang === "en" ? 6 : 0,
                                                                borderBottomLeftRadius: lang === "en" ? 6 : 0,
                                                                borderTopRightRadius: lang === "en" ? 0 : 6,
                                                                borderBottomRightRadius: lang === "en" ? 0 : 6,
                                                            }),
                                                            menu: (baseStyles, state) => ({
                                                                ...baseStyles,
                                                                direction: 'ltr'
                                                            }),
                                                            valueContainer: (baseStyles, state) => ({
                                                                ...baseStyles,
                                                                direction: 'ltr'
                                                            }),
                                                        }}
                                                    />
                                                    <InputNumber
                                                        invalid={(formError && checkForFormError(phone))}
                                                        value={phone}
                                                        onChange={(e) => {
                                                            setPhone(e.value);
                                                        }}
                                                        className='pr-input'
                                                        useGrouping={false}
                                                        inputStyle={{
                                                            borderTopLeftRadius: lang === "en" ? 0 : 6,
                                                            borderBottomLeftRadius: lang === "en" ? 0 : 6,
                                                            borderTopRightRadius: lang === "en" ? 6 : 0,
                                                            borderBottomRightRadius: lang === "en" ? 6 : 0,
                                                            borderRight: lang === "en" ? 'auto' : "none",
                                                            borderLeft: 'auto'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-3">
                                        <h6 className='text-xl'>{t('fill_the_delievery_address')}</h6>
                                        <div className='grid lg:grid-cols-2 md:grid-cols-2 gap-3'>

                                            <div>
                                                <div className="form-group">
                                                    <label htmlFor="country" className='mb-1 required'>{t('country')}</label>
                                                    <Select
                                                        value={country}
                                                        options={countries}
                                                        getOptionLabel={(c) => c.name}
                                                        getOptionValue={(c) => c.code3}
                                                        onChange={(e) => {
                                                            setCountry(e);
                                                            setSelectedState('');
                                                            setStates(e.states);
                                                        }}
                                                        className='pr-input'
                                                        placeholder={t('select')}
                                                    />
                                                </div>
                                            </div>

                                            <div>
                                                <div className="form-group">
                                                    <label htmlFor="governorate" className='mb-1 required'>{t('governorate_state_emirate')}</label>
                                                    <Select
                                                        aria-invalid={true}
                                                        className='pr-input'
                                                        options={states}
                                                        value={selectedState}
                                                        getOptionLabel={(s) => s.name}
                                                        getOptionValue={(s) => s.name}
                                                        onChange={(e) => {
                                                            setSelectedState(e);
                                                            loadShippingCost(e.code);
                                                        }}
                                                        placeholder={t('select')}
                                                        styles={{
                                                            control: (baseStyles, state) => ({
                                                                ...baseStyles,
                                                                borderColor: (formError && checkForFormError(selectedState.name)) ? 'red' : '#CCC',
                                                            }),

                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            <div>
                                                <div className="form-group">
                                                    <label htmlFor="city" className='mb-1 required'>{t('city_town')}</label>
                                                    <InputText
                                                        className='pr-input'
                                                        value={city}
                                                        onChange={(e) => {
                                                            setCity(e.target.value);
                                                        }}
                                                        invalid={formError && checkForFormError(city)}
                                                    />
                                                </div>
                                            </div>

                                            <div>
                                                <div className="form-group">
                                                    <label htmlFor="block" className='mb-1 required'>{t('block_area_zone')}</label>
                                                    <InputText
                                                        className='pr-input'
                                                        value={area}
                                                        onChange={(e) => {
                                                            setArea(e.target.value);
                                                        }}
                                                        invalid={formError && checkForFormError(area)}
                                                    />
                                                </div>
                                            </div>

                                            <div>
                                                <div className="form-group">
                                                    <label htmlFor="street" className='mb-1 required'>{t('street')}</label>
                                                    <InputText
                                                        className='pr-input'
                                                        value={street}
                                                        onChange={(e) => {
                                                            setStreet(e.target.value);
                                                        }}
                                                        invalid={formError && checkForFormError(street)}
                                                    />
                                                </div>
                                            </div>

                                            <div>
                                                <div className="form-group">
                                                    <label htmlFor="street" className='mb-1 required'>{t('house')}</label>
                                                    <InputText
                                                        className='pr-input'
                                                        value={house}
                                                        onChange={(e) => {
                                                            setHouse(e.target.value);
                                                        }}
                                                        invalid={formError && checkForFormError(house)}
                                                    />
                                                </div>
                                            </div>

                                            <div>
                                                <div className="form-group">
                                                    <label htmlFor="apartment" className='mb-1'>{t('apartment')}</label>
                                                    <InputText
                                                        className='pr-input'
                                                        value={apt}
                                                        onChange={(e) => {
                                                            setApt(e.target.value);
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            <div>
                                                <div className="form-group">
                                                    <label htmlFor="notes" className='mb-1'>{t('notes')}</label>
                                                    <InputText
                                                        value={notes}
                                                        onChange={(e) => {
                                                            setNotes(e.target.value);
                                                        }}
                                                        className='pr-input'
                                                    />
                                                </div>
                                            </div>
                                            {/* <div>
                                                <div className="form-group mt-2">
                                                    <div className="flex align-items-center">
                                                        <Checkbox inputId="createAccount"
                                                            name="createAccount"
                                                            value={createAccount}
                                                            onChange={() => {
                                                                setCreateAccount(!createAccount)
                                                            }}
                                                            checked={createAccount}
                                                        />
                                                        <label htmlFor="createAccount" className="ml-2">{t('create_new_account')}</label>
                                                    </div>
                                                </div>
                                            </div> */}
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="col-span-12 lg:col-span-5">
                            <div className='bg-gray-50 rounded-md lg:p-7 p-2'>
                                <div className='mt-3'>
                                    <span className='text-3xl p-2'>{t('cart_summary')}</span>
                                </div>
                                <div className='p-3'>
                                    <div className="flex justify-between mb-4">
                                        <span className='font-semibold'>{t('total_items')}</span>
                                        <span className='text-xl'><strong>{cartItems.length}</strong></span>
                                    </div>
                                    <div className="flex justify-between mb-4">
                                        <span className='font-semibold'>{t('total_quantity')}</span>
                                        <span><strong className='text-xl'>{cartPrice.totalQuantity}</strong>  <span>{t('items')}</span></span>
                                    </div>

                                    <div className="flex justify-between mb-4">
                                        <span className='font-semibold'>{t('sub_total')}</span>
                                        <span className='text-xl'><strong>{formatPrice(cartPrice.subTotal)}</strong></span>
                                    </div>
                                    <div className="flex justify-between mb-4">
                                        <span className='font-semibold'>{t('you_saved')}</span>
                                        <span className='text-xl text-red-600'>-<strong>{formatPrice(cartPrice.saved)}</strong></span>
                                    </div>
                                    <div className="flex justify-between">
                                        <span className='font-semibold'>{t('shipping')}</span>
                                        <span className='text-xl'><strong>{formatPrice(cartPrice.shippingCharge)}</strong></span>
                                    </div>
                                    {
                                        cartPrice.grandTotal < shippingConfig.freeShippingAfter &&
                                        <div className='mb-4'>
                                            <span className='text-sm mx-1'>{formatPrice(shippingConfig.freeShippingAfter)} {t('away_from_free_shipping')}</span>
                                        </div>
                                    }

                                    <hr className='mt-3 mb-4' />
                                    {
                                        config.enableCOD &&
                                        <div className="flex justify-between mb-4">
                                            <span className='font-semibold'>{t('cash_on_delivery')}</span>
                                            <span>
                                                <InputSwitch
                                                    checked={paymentMode === "cod"}
                                                    onChange={() => {
                                                        setPaymentMode('cod')
                                                    }}
                                                />
                                            </span>
                                        </div>
                                    }
                                    {
                                        config.enableOnlinePayment &&
                                        <div className="flex justify-between mb-4">
                                            <span className='font-semibold'>{t('pay_online')}</span>
                                            <span>
                                                <InputSwitch
                                                    checked={paymentMode === "online"}
                                                    onChange={() => {
                                                        setPaymentMode('online')
                                                    }}
                                                />
                                            </span>
                                        </div>
                                    }


                                    <hr className='mt-3' />

                                    <div className="flex justify-between mt-4">
                                        <span className='text-xl font-semibold'>{t('grand_total')}</span>
                                        <span className='text-xl'><strong>{formatPrice(cartPrice.grandTotal + cartPrice.shippingCharge)}</strong></span>
                                    </div>
                                    <div className='mt-4'>
                                        <Button label={t('place_order')} rounded className='w-full' severity="secondary"
                                            onClick={() => {
                                                handleCheckoutCart();
                                            }}
                                            loading={btnLoading}
                                        />
                                    </div>
                                </div>
                            </div>
                            {/* <div className="mt-4">
                                <div className="bg-gray-50 p-4 rounded-md">
                                    <div className='my-3'>
                                        <h6>{t('have_a_coupon_code')}</h6>
                                    </div>
                                    <InputText
                                        placeholder={t('enter_coupon_code')}
                                        className='pr-input'
                                    />
                                    <div className='mt-3'>
                                        <Button outlined label={t('apply_coupon_code')} rounded severity="secondary" />
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}
export default Checkout;

